import React from "react";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { walletRetrieve } from "../../Services/MainService";
import { format, isSameDay, isToday, isYesterday } from "date-fns";

const Wallet = () => {
  const [wallet, setWallet] = React.useState([]);
  const [walletLoading, setWalletLoading] = React.useState(false);
  const [type, setType] = React.useState("debit");
  const [availableBalance, setAvailableBalance] = React.useState(0);
  React.useEffect(() => {
    fetchWallet();
  }, []);
  const fetchWallet = () => {
    setWalletLoading(true);
    walletRetrieve().then(
      (res) => {
        setWallet(res.data);
        let balance = 0;
        res.data.forEach((x) => {
          balance += x.balance;
        });
        setAvailableBalance(balance);
        setWalletLoading(false);
      },
      (er) => {
        console.warn(er);
        toast.error("Something went wrong while fetching wallet.");
      }
    );
  };
  return (
    <div className="container py-4">
      <div
        className="row justify-content-center"
        style={{ minHeight: "calc(80vh - 134px)" }}
      >
        <div className="col-xl-4 col-lg-6 col-md-8 col-12">
          {walletLoading ? (
            <div className="text-center">
              <Spinner variant="primary" />
            </div>
          ) : !wallet ? null : (
            <>
              <div
                className="app-bg-dark py-4 px-3"
                style={{ borderRadius: "18px" }}
              >
                <small className="" style={{ color: "#E3E3E3" }}>
                  Available balance
                </small>
                <h3 className="text-white fw-bold mb-0">
                  Rs. {availableBalance.toLocaleString()}
                </h3>
              </div>
              <div className="d-flex flex-warp justify-content-around py-4">
                <button
                  className={`btn btn-sm btn-${
                    type == "credit" ? "dark" : "light"
                  } cwb px-3 py-2`}
                  onClick={() => setType("credit")}
                >
                  Credit History
                </button>

                <button
                  className={`btn btn-sm btn-${
                    type == "debit" ? "dark" : "light"
                  } cwb px-3 py-2`}
                  onClick={() => setType("debit")}
                >
                  Debit History
                </button>
              </div>
              <div className="row gy-3 mx-0">
                {wallet.map((x) =>
                  x.transections
                    .filter((y) => y.transection_type == type)
                    .map((y) => (
                      <div className="col-12 cwb d-flex align-items-start justify-content-between px-3 py-3">
                        <i
                          className={`mt-2 fa-solid fa-arrow-up text-${
                            y.transection_type == "credit"
                              ? "success"
                              : "danger"
                          } fs-3`}
                        ></i>
                        <div style={{ flex: 1 }} className="ps-4">
                          <span
                            className="d-block mb-1"
                            style={{ color: "#a3a3a3" }}
                          >
                            {isToday(y.updated_at)
                              ? "Today"
                              : isYesterday(y.updated_at)
                              ? "Yesterday"
                              : ""}
                            {format(
                              y.updated_at,
                              `${
                                !isToday(y.updated_at) &&
                                !isYesterday(y.updated_at)
                                  ? "dd MMM yyyy"
                                  : ""
                              }, p`
                            )}
                          </span>
                          <small
                            className="d-block"
                            style={{ color: "#a3a3a3" }}
                          >
                            Reference ID: {y.reference_id || "---"}
                          </small>
                          <small
                            className="d-block"
                            style={{ color: "#a3a3a3" }}
                          >
                            Reference Note: {x.note || "---"}
                          </small>
                        </div>
                        <span
                          className={`fs-5 text-${
                            y.transection_type == "credit"
                              ? "success"
                              : "danger"
                          }`}
                        >
                          Rs. {parseInt(y.amount).toLocaleString()}
                        </span>
                      </div>
                    ))
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Wallet;
